export type ButtonSize = "small" | "medium" | "big";
export type ButtonVariant = "primary" | "secondary" | "link" | "icon" | "border" | "default" | "text" | "dashed";
export type ButtonTone = "default" | "transparent" | "danger";

export const HEIGHT_MAP: Record<ButtonSize, string> = {
  small: "var(--button-height-small)",
  medium: "var(--button-height-medium)",
  big: "var(--button-height-big)",
};

const primaryStyles = {
  default: {
    backgroundColor: "var(--button-primary-bg)",
    color: "var(--button-primary-text)",
  },
  hover: {
    backgroundColor: "var(--button-primary-bg-hover)",
    color: "var(--button-primary-text)",
  },
  focus: {
    backgroundColor: "var(--button-primary-bg-focus)",
    color: "var(--button-primary-text)",
  },
  disabled: {
    backgroundColor: "var(--button-primary-bg-disabled)",
    color: "var(--button-primary-text)",
  },
};

const secondaryStyles = {
  default: {
    backgroundColor: "var(--button-secondary-bg)",
    color: "var(--button-secondary-text)",
    border: "1px solid var(--button-secondary-border)",
  },
  hover: {
    backgroundColor: "var(--button-secondary-bg-hover)",
    color: "var(--button-secondary-text)",
    border: "1px solid var(--button-secondary-border)",
  },
  focus: {
    backgroundColor: "var(--button-secondary-bg-focus)",
    color: "var(--button-secondary-text)",
    border: "1px solid var(--button-secondary-border-focus)",
  },
  disabled: {
    backgroundColor: "var(--button-secondary-bg-disabled)",
    color: "var(--button-secondary-text-disabled)",
    border: "1px solid var(--button-secondary-border)",
  },
};

const dangerPrimaryStyles = {
  default: {
    backgroundColor: "var(--button-danger-primary-bg)",
    color: "var(--button-danger-primary-text)",
  },
  hover: {
    backgroundColor: "var(--button-danger-primary-bg-hover)",
    color: "var(--button-danger-primary-text)",
  },
  focus: {
    backgroundColor: "var(--button-danger-primary-bg-focus)",
    color: "var(--button-danger-primary-text)",
  },
  disabled: {
    backgroundColor: "var(--button-danger-primary-bg-disabled)",
    color: "var(--button-danger-primary-text)",
  },
};

const dangerSecondaryStyles = {
  default: {
    backgroundColor: "var(--button-danger-secondary-bg)",
    color: "var(--button-danger-secondary-text)",
    border: "1px solid var(--button-danger-secondary-border)",
  },
  hover: {
    backgroundColor: "var(--button-danger-secondary-bg-hover)",
    color: "var(--button-danger-secondary-text)",
    border: "1px solid var(--button-danger-secondary-border)",
  },
  focus: {
    backgroundColor: "var(--button-danger-secondary-bg-focus)",
    color: "var(--button-danger-secondary-text)",
    border: "1px solid var(--button-danger-secondary-border-focus)",
  },
  disabled: {
    backgroundColor: "var(--button-danger-secondary-bg-disabled)",
    color: "var(--button-danger-secondary-text-disabled)",
    border: "1px solid var(--button-danger-secondary-border)",
  },
};

type StateStyles = Record<"default" | "hover" | "focus" | "disabled", Record<string, string>>;

export const VARIANT_STYLES: Record<
  "primary" | "secondary" | "danger-primary" | "danger-secondary",
  StateStyles
> = {
  primary: primaryStyles,
  secondary: secondaryStyles,
  "danger-primary": dangerPrimaryStyles,
  "danger-secondary": dangerSecondaryStyles,
};

export const ICON_SIZE_MAP: Record<ButtonSize, number> = {
  small: 24,
  medium: 32,
  big: 40,
};
